import { Injectable, NgModule } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, combineLatest, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, mergeMap } from 'rxjs/operators';
import { SYSTEM_VERSION } from 'src/version';
import { Store } from '@ngrx/store';
import { selectContextEntity } from '../store/selectors/context.selectors';
import * as moment from 'moment';
import { Auth } from '@angular/fire/auth';
import { idToken } from  '@angular/fire/auth';
import { EntityService } from 'src/app/features/entity/services/entity.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private auth: Auth,
    private store: Store<any>,
    private sEntity: EntityService
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const api = environment.api.host;
    const version = SYSTEM_VERSION;
    const fingerprint = localStorage.getItem('notification_fp');
    const dbName = localStorage.getItem('dbname');


    // do not put headers on external api calls
    if (!req.url.startsWith(api) && !req.url.startsWith('api/')) {
      return next.handle(req);
    }

    const context$ = this.store.select(selectContextEntity);

    let token$: Observable<string>;
    let loggedEmail: string;

    const isDevOffline = environment.environment == 'local' && localStorage.getItem('offline') == 'true';
    if (isDevOffline) {
      const loggedEmail = this.sEntity.loggedUser?.email || localStorage.getItem('logged_email');

      if (loggedEmail) {
        const storedString = localStorage.getItem('localfbuser-' + loggedEmail);
        if (storedString) {
          const storedData = JSON.parse(storedString);
          if (storedData && storedData.token) {
            token$ = of(storedData.token);
          } else {
            token$ = idToken(this.auth).pipe(map(token => {
              storedData.token = token;
              localStorage.setItem('localfbuser-' + loggedEmail, JSON.stringify(storedData));
              return token;
            }));
          }
        } else {
          token$ = idToken(this.auth).pipe(map(token => {
            let storedData = { token };
            localStorage.setItem('localfbuser-' + loggedEmail, JSON.stringify(storedData));
            return token;
          }));
        }
      }
    }

    if (!token$) {
      token$ = idToken(this.auth);
    }

    return combineLatest([context$, token$])
      .pipe(
        mergeMap(([context, token]) => {
          let header = req.clone({
            headers: req.headers.set('AppVersion',
              version.version)
          });

          const tz = moment().format('ZZ');

          header = header.clone({
            headers: header.headers.set('gio-client-timezone', tz)
          });

          if (environment.environment != 'production' && dbName){
            header = header.clone({
              headers: header.headers.set('gio-dbname', dbName)
            });
          }

          if (environment.environment == 'local' && loggedEmail) {
            header = header.clone({
              headers: header.headers.set('gio-local-email', loggedEmail)
            });
          }

          const tzName = moment.tz?.guess();
          if (tzName) {
            header = header.clone({
              headers: header.headers.set('gio-client-timezone-name', tzName)
            });
          }

          if (context) {
            header = header.clone({
              headers: header.headers.set('contextid', context.id.toString())
            });
          }

          if (fingerprint) {
            header = header.clone({
              headers: header.headers.set('device-print', fingerprint)
            });
          }


          if (token) {
            header = header.clone({
              headers: header.headers.set('Authorization',
                'Bearer ' + token)
            });

          }
          return next.handle(header);
        })
      );

  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class ApiInterceptor { }
